export default __webpack_public_path__ + "static/media/rocket_anim_1.3da2bc42.png";